const Close = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="white"

    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.8} clipPath="url(#clip0_119_589)">
      <path
        d="M25.3337 8.54699L23.4537 6.66699L16.0003 14.1203L8.54699 6.66699L6.66699 8.54699L14.1203 16.0003L6.66699 23.4537L8.54699 25.3337L16.0003 17.8803L23.4537 25.3337L25.3337 23.4537L17.8803 16.0003L25.3337 8.54699Z"
      />
    </g>
  </svg>
);

export default Close;